import React from 'react';
import PropTypes from 'prop-types';

const MessageInputErrorBar = ({ text }) => (
  <div className="message-input-error-bar">
    {text}
  </div>
);

MessageInputErrorBar.propTypes = {
  text: PropTypes.string,
};

export default MessageInputErrorBar;
